<template>
  <div class="credit">
    <!--内容区域-->
    <!--新增/删除按钮-->
    <vxe-toolbar>
      <template v-slot:buttons>
        <vxe-button size="mini" type="primary" class="vxe-btn-primary" @click="exportData">
          导出</vxe-button
        >
      </template>
    </vxe-toolbar>
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="false"
        @chooseClick="chooseClick"
        @currentChange="currentChange"
        @dblclickEvent="dblclickEvent"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
        @sortChangeEvent="sortChangeEvent"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :width="item.width"
          :sortable="item.sortable"
          :field="item.prop"
          :title="item.label"
        >
        </vxe-table-column>
      </sirui-table>
    </div>
  </div>
</template>

<script>
  // import axios from 'axios';
  import { mapState } from 'vuex';
  import API from '@/api/purchaseSalesCenter/credit/statistics.js';
  import SiruiTable from '@/components/SiruiTable';

  export default {
    components: {
      SiruiTable,
    },
    name: 'creditStatisticsDetail',
    data() {
      return {
        load: false,
        img: '/static/img/tips.png',
        query: {
          businessDepartment: '', //事业部门
          partnerType: '', //合作伙伴类型
          onlyShow: '', //只显示母公司额度
          partner: '', //业务合作伙伴
          creditCode: '', //信用账户号
        },
        customerNo: '',
        multipleSelection: [], //存放选中的值
        menuButtonList: [],
        tableData: [],
        businessDepartmentList: [], //事业部门下拉列表
        partnerTypeList: [], //企业类型下拉列表
        requestStatusList: [], //申请状态下拉列表
        creditTypeList: [], //授信类型下拉列表
        accountsTypeList: [], //账款类型下拉列表
        rowData: {}, //被选中的列
      };
    },
    computed: {
      //表格显示字段
      columnList() {
        return [
          {
            prop: 'partnerCode',
            label: this.$t('creditStatistics.detail.partnerCode'),
            width: 120,
          },
          {
            prop: 'customerName',
            label: this.$t('creditStatistics.detail.partnerName'),
            width: 120,
          },
          { prop: 'contractNo', label: this.$t('creditStatistics.detail.contractNo'), width: 120 },
          {
            prop: 'tradeTypeName',
            label: this.$t('creditStatistics.detail.contractType'),
            width: 120,
          },
          { prop: 'contractDetailNo', label: this.$t('creditStatistics.detail.shops'), width: 120 },
          { prop: 'productNo', label: this.$t('creditStatistics.detail.partNo'), width: 120 },
          { prop: 'productDesc', label: this.$t('creditStatistics.detail.partMark'), width: 120 },
          { prop: 'productQuantity', label: this.$t('creditStatistics.detail.number'), width: 120 },
          { prop: 'unitName', label: this.$t('creditStatistics.detail.unit'), width: 120 },
          {
            prop: 'businessContractUnitPrice',
            label: this.$t('creditStatistics.detail.unitPrice'),
            width: 120,
          },
          {
            prop: 'businessContractTotalAmount',
            label: this.$t('creditStatistics.detail.total'),
            width: 120,
          },
          {
            prop: 'contractCurrencyName',
            label: this.$t('creditStatistics.detail.currency'),
            width: 120,
          },
          {
            prop: 'contractBusinessDepartmentName',
            label: this.$t('creditStatistics.detail.department'),
            width: 120,
          },
          {
            prop: 'companyContractTotalAmount',
            label: this.$t('creditStatistics.detail.homeCurrency'),
            width: 120,
          },
        ];
      },
      ...mapState({
        creditInfo: (state) => state.creditInfo,
      }),
    },
    /**页面必要代码Start */
    mounted() {
      this.getData();
    },
    methods: {
      //获取数据
      getData() {
        this.load = true;
        this.$axios.get(API.ORDER_APPLICATION_STATISTICS_API + this.$route.query.id).then((res) => {
          this.load = false;
          if (0 == res.data.code) {
            this.tableData = res.data.data;
            this.tableData.find((it) => {
              if (it.contractCategory == 'purchase') {
                it.customerName = it.supplierName;
              }
            });
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      //搜索
      detailBtnClick() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.getData();
      },
      //重置
      resetBtnClick() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.getData();
      },
      //每页条数
      handleSizeChange() {
        this.getData();
      },
      //第几页
      handleCurrentChange() {
        this.getData();
      },
      //checkbox选中触发事件
      handleSelectionChange(row) {
        this.multipleSelection = row;
      },
      //表格选中事件
      currentChange(row) {
        if (JSON.stringify(this.rowData) == '{}' || this.rowData.id != row.id) {
          this.rowData = row;
        } else if (this.rowData.id == row.id) {
          this.rowData = {};
        }
      },
      //调用接口排序
      sortChangeEvent({ column, property, order }) {
        console.info(column, property, order);
      },
      //点击按钮触发的方法
      chooseClick(type) {
        //新增
        if (type === 'add') {
          this.add();
        } else if (type === 'del') {
          //删除
          //判断按钮类型--删除
          this.del();
        } else if (type === 'edit') {
          if (JSON.stringify(this.multipleSelection) == '{}') {
            this.$message({
              showClose: true,
              message: this.$t('applicationCredit.msg.noSelectEdit'),
              type: 'error',
            });
          } else {
            let path = {
              title: '',
              path: 'creditAdd',
              name: '',
              query: { id: 1 },
            };
            this.$store.commit('LIST_ADD_TABS', path);
          }
        }
      },
      //新增
      add() {
        let path = {
          title: '',
          path: 'creditAdd',
          name: '',
          query: { id: 1 },
        };
        this.$store.commit('LIST_ADD_TABS', path);
      },
      //删除
      del() {
        let ids = [];
        this.multipleSelection.map((item) => {
          ids.push(item.id);
        });
        this.$confirmAction()
          .then(() => {
            //TODO调用接口
            //如果操作成功，直接返回列表
            this.$message({
              type: 'success',
              message: this.$t('message.success'),
            });
            //如果有错误返回，提示信息
            this.$alert(this.$t('applicationCredit.msg.errText'));
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      //双击事件
      dblclickEvent(value) {
        let path = {
          title: '',
          path: 'creditDetail',
          name: '',
          query: { creditRequestNo: value.row.creditRequestNo },
        };
        this.$store.commit('LIST_ADD_TABS', path);
      },
      exportData() {
        this.load = true;
        this.$axios.post(API.EXPORT_SUMMARY_ANALYSIS, { id: this.$route.query.id }).then((res) => {
          this.load = false;
          if (0 == res.data.code) {
            window.location.href = res.data.data;
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      /**页面必要代码End */
    },
  };
</script>
